/**
 * Formats dashboard filters into a stringified JSON payload for the API.
 * @param {Object} filters - Object containing the filter states
 * @returns {Object} Prepared data payload
 */
export const generateFetchDataPayload = (filters) => {
    const format = (filter) =>
        JSON.stringify(filter?.newValue?.length > 0 ? filter.newValue : []);

    return {
        globalIntake: format(filters.filterIntake),
        globalSchool: format(filters.filterSchool),
        globalLearningMethod: format(filters.filterLearningMethod),
        globalLecturer: format(filters.filterLecturer)
    };
};

/**
 * Util function to get a class name to apply to the amount of digits for notifications.
 * @param {number} value Amount to apply class to.
 * @returns Class-Name
 */
export function getDigitClass(value) {
    if (!value) {
        return "";
    } else if (value > 999 && value < 10000) {
        return "four-digit";
    } else if (value > 9999 && value < 100000) {
        return "five-digit";
    } else if (value > 99 && value < 1000) {
        return "three-digit";
    }
    return "";
};

/**
 * Maximum retries allowed for this API call. It's a heavy API call this one.
 */
export const MAX_DASHBOARD_RETRY_ATTEMPTS = 5;

/**
 * Triggers an exponential backoff timer to increment a retry state.
 * @param {number} retryCount - The current attempt number.
 * @param {Function} setRetryCount - React state setter for the retry count.
 * @param {number} baseDelay - Base multiplier in milliseconds (default 1000ms).
 */
export function triggerExponentialBackoff (retryCount, setRetryCount, baseDelay = 1000) {
    const backoffDelay = Math.pow(2, retryCount) * baseDelay;

    console.log(`Backoff triggered: Retrying in ${backoffDelay}ms (Attempt ${retryCount + 1})`);

    return setTimeout(() => {
        setRetryCount((prev) => prev + 1);
    }, backoffDelay);
};
